import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Instagram, Facebook, Linkedin, Youtube } from "lucide-react";

const SOCIAL_LINKS = [
  { label: "Instagram", url: "https://www.instagram.com/outdoordisplayproducts/", icon: Instagram },
  { label: "Facebook", url: "https://www.facebook.com/outdoorbannerframe/", icon: Facebook },
  { label: "LinkedIn", url: "https://www.linkedin.com/company/outdoor-display-products-llc", icon: Linkedin },
  { label: "YouTube", url: "https://www.youtube.com/@thebannerbar", icon: Youtube },
];

const PRODUCT_LINKS = [
  { label: "All Kits & Hardware", path: "/products" },
  { label: "Compare All Kits", path: "/compare" },
  { label: "Small Form Kit", path: "/products/small-form-kit" },
  { label: "Two Post Kit", path: "/products/two-post-kit" },
  { label: "Three Post Kit", path: "/products/three-post-kit" },
  { label: "V-Config Kit", path: "/products/v-config-kit" },
  { label: "Replacement Bungees", path: "/products/replacement-bungees" },
];

const RESOURCE_LINKS = [
  { label: "Benefits", path: "/benefits" },
  { label: "Installation Videos", path: "/installation" },
  { label: "FAQs", path: "/faqs" },
  { label: "Banner Bar Wins", path: "/frame-comparison" },
  { label: "Where to Buy T-Posts", path: "/tpost-guide" },
  { label: "Dealer Assets", path: "/dealer-assets" },
  { label: "News", path: "/news" },
  { label: "Quality Guarantee", path: "/quality-guarantee" },
  { label: "About", path: "/about" },
];

const BUYER_LINKS = [
  { label: "Corporate & Franchise", path: "/corporate" },
  { label: "Cities, Schools & Institutions", path: "/institutions" },
  { label: "Wholesale Portal", path: "/dealer-portal" },
  { label: "Dealer Locator", path: "/dealer-locator" },
  { label: "Become a Dealer", path: "/dealer-portal" },
  { label: "Contact", path: "/contact" },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-girder bg-[#05070c]" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-12">
        <div>
          <div className="flex items-center">
            <img src="/assets/brand/logo-horizontal.png" alt="The Banner Bar" className="h-10 w-auto" />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-slate-400">
            The patented outdoor banner frame system that keeps banners standing, readable and professional in real wind. U.S. Patent 10,410,553 B2. Made in the USA.
          </p>
          <p className="mt-4 font-mono text-xs uppercase tracking-widest text-slate-500">Outdoor Display Products LLC</p>
          <div className="mt-4 flex items-center gap-3" data-testid="footer-social-links">
            {SOCIAL_LINKS.map((s) => (
              <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={`The Banner Bar on ${s.label}`} data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="flex h-9 w-9 items-center justify-center border border-girder text-slate-400 transition-colors hover:border-hivis hover:text-hivis">
                <s.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-hivis">Kits & Hardware</h3>
          <ul className="mt-5 space-y-2.5">
            {PRODUCT_LINKS.map((l) => (
              <li key={l.label}><Link to={l.path} className="text-sm text-slate-400 transition-colors hover:text-slate-100" data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-hivis">Resources</h3>
          <ul className="mt-5 space-y-2.5">
            {RESOURCE_LINKS.map((l) => (
              <li key={l.label}><Link to={l.path} className="text-sm text-slate-400 transition-colors hover:text-slate-100">{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-hivis">Buyers</h3>
          <ul className="mt-5 space-y-2.5">
            {BUYER_LINKS.map((l) => (
              <li key={l.label}><Link to={l.path} className="text-sm text-slate-400 transition-colors hover:text-slate-100">{l.label}</Link></li>
            ))}
          </ul>
          <div className="mt-8 space-y-2.5 text-sm text-slate-400">
            <p className="flex items-center gap-2"><Phone className="h-3.5 w-3.5 text-hivis" /> 970-650-5173</p>
            <p className="flex items-center gap-2"><MapPin className="h-3.5 w-3.5 text-hivis" /> Montrose, CO 81401</p>
            <p className="flex items-center gap-2"><Clock className="h-3.5 w-3.5 text-hivis" /> 8am - 5pm MST</p>
          </div>
        </div>
      </div>
      <div className="border-t border-girder py-6 text-center font-mono text-[11px] uppercase tracking-widest text-slate-600">
        © 2026 Outdoor Display Products LLC — All Rights Reserved — U.S. Patent 10,410,553 B2
      </div>
    </footer>
  );
}
